import React from "react";

const StudentDashboard = () => {
    return (
        <div>
        <h1>Student Dashboard</h1>
        <ul>
            <li>View and update profile information</li>
            <li>Check attendance records</li>
            <li>Report issues or feedback</li>
            <li>Access class notes and recorded lectures</li>
            <li>Apply for leave</li>
            <li>View exam schedules and results</li>
        </ul>
        </div>
    );
}
export default StudentDashboard;